import styled from 'styled-components';

import { colorBlack900, fontFamilyPrimary } from 'styles';

export const TabsLegendRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  width: 100%;
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  flex-shrink: 0;
  margin-left: auto;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${fontFamilyPrimary};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.36px;
  color: ${colorBlack900};
`;

export const LegendDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const ChartWrapper = styled.div`
  width: 100%;
  height: 280px;
  position: relative;

  & > div {
    width: 100%;
    height: 100%;
  }
`;
